"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultizeZoom = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _constants = require("../../../constants");
const defaultZoomOptions = {
  minStart: 0,
  maxEnd: 100,
  step: 5,
  minSpan: 10,
  maxSpan: 100,
  panning: true,
  filterMode: 'keep',
  slider: {
    enabled: false,
    size: _constants.DEFAULT_ZOOM_SLIDER_SIZE
  }
};
const defaultizeZoom = (zoom, axisId, axisDirection) => {
  if (!zoom) {
    return undefined;
  }
  if (zoom === true) {
    return (0, _extends2.default)({
      axisId,
      axisDirection
    }, defaultZoomOptions);
  }
  return (0, _extends2.default)({
    axisId,
    axisDirection
  }, defaultZoomOptions, zoom, {
    slider: (0, _extends2.default)({}, defaultZoomOptions.slider, zoom.slider)
  });
};
exports.defaultizeZoom = defaultizeZoom;